import { UserCard } from './UserCard';
import { Container, Row } from 'react-bootstrap';
import React from 'react';
import { Loader } from '../../../../components/Loader';
import { ErrorMessage } from '../../../../components/ErrorMessage';
import { readAllActiveUsers } from '../api';
import { useQuery } from '@apollo/client';

export const ListActiveUsers = () => {
  const { loading, error, data } = useQuery(readAllActiveUsers);
  if (loading) return <Loader title='Loading active users...' />;
  if (error) return <ErrorMessage title='An error occurred while trying to load the active users.' />;

  return (
    <Container fluid={true} className='mt-3'>
      <Row>
        {data.readAllActiveUsers.map((user: any, index: number) => (
          <UserCard key={index} user={user} />
        ))}
      </Row>
    </Container>
  );
};
